import { render, staticRenderFns } from "./spReform.vue?vue&type=template&id=459d64eb"
import script from "./spReform.vue?vue&type=script&lang=js"
export * from "./spReform.vue?vue&type=script&lang=js"
import style0 from "./spReform.vue?vue&type=style&index=0&id=459d64eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports